/* ZenShade — interactions. Loaded with defer, no dependencies. */
(function () {
  'use strict';
  if (window.__zsLoaded) return;
  window.__zsLoaded = true;

  function money(cents, box) {
    var cur = (box && box.getAttribute('data-currency')) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-zs-play]');
    if (!play) return;
    var wrap = play.closest('[data-zs-video]');
    if (!wrap || wrap.getAttribute('data-playing') === 'true') return;
    var tpl = wrap.querySelector('[data-zs-video-src]');
    if (!tpl) return;
    var poster = wrap.querySelector('img');
    if (poster) poster.style.display = 'none';
    wrap.appendChild(tpl.content.cloneNode(true));
    wrap.setAttribute('data-playing', 'true');
    var v = wrap.querySelector('video');
    if (v) v.play().catch(function () {});
  });

  function setMain(gal, src, alt) {
    var main = gal && gal.querySelector('[data-zs-main] img');
    if (!main || !src) return;
    main.removeAttribute('srcset');
    main.src = src;
    if (alt) main.alt = alt;
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-zs-thumb]');
    if (!thumb) return;
    var gal = thumb.closest('[data-zs-gallery]');
    setMain(gal, thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'));
    gal.querySelectorAll('[data-zs-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  function renderOffers(box, variant) {
    var price = variant.price, compare = Math.max(variant.compare_at_price || 0, variant.price);
    box.querySelectorAll('[data-zs-offer]').forEach(function (o) {
      var q = +o.getAttribute('data-qty'), rate = +o.getAttribute('data-rate');
      var total = Math.round(price * q * rate / 100), was = compare * q;
      o.setAttribute('data-total', total);
      var n = o.querySelector('[data-zs-now]'), w = o.querySelector('[data-zs-was]'), s = o.querySelector('[data-zs-saving]');
      if (n) n.textContent = money(total, box);
      if (w) { w.textContent = money(was, box); w.hidden = was <= total; }
      if (s) { s.textContent = was > total ? s.getAttribute('data-prefix') + ' ' + money(was - total, box) : s.getAttribute('data-fallback'); }
    });
    var sel = box.querySelector('[data-zs-offer][aria-checked="true"]');
    syncTotals(box, sel);
  }

  function syncTotals(box, offer) {
    if (!offer) return;
    var total = money(+offer.getAttribute('data-total'), box);
    var qty = box.querySelector('[data-zs-qty]');
    if (qty) qty.value = offer.getAttribute('data-qty');
    var st = document.querySelector('[data-zs-sticky-price]');
    if (st) st.textContent = total;
  }

  document.addEventListener('click', function (e) {
    var offer = e.target.closest('[data-zs-offer]');
    if (offer) {
      var box = offer.closest('[data-zs-buybox]');
      box.querySelectorAll('[data-zs-offer]').forEach(function (o) {
        o.setAttribute('aria-checked', o === offer ? 'true' : 'false');
      });
      syncTotals(box, offer);
      return;
    }
    var opt = e.target.closest('[data-zs-opt]');
    if (opt) {
      var set = opt.closest('[data-zs-optset]');
      set.querySelectorAll('[data-zs-opt]').forEach(function (o) {
        o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
      });
      set.querySelector('input[type="hidden"]').value = opt.getAttribute('data-value');
      var lbl = set.querySelector('[data-zs-optval]');
      if (lbl) lbl.textContent = opt.getAttribute('data-value');
      resolveVariant(opt.closest('[data-zs-buybox]'));
    }
    var stickyBtn = e.target.closest('[data-zs-sticky-btn]');
    if (stickyBtn) {
      var main = document.querySelector('[data-zs-submit]');
      if (main && !main.disabled) main.click();
      else if (main) window.scrollTo({ top: main.getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth' });
    }
  });

  function resolveVariant(box) {
    var data = box.querySelector('[data-zs-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var chosen = Array.prototype.map.call(box.querySelectorAll('[data-zs-optset] input[type="hidden"]'), function (i) { return i.value; });
    var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
    var idInput = box.querySelector('[name="id"]');
    var button = box.querySelector('[data-zs-submit]');
    if (match && idInput) idInput.value = match.id;
    var ok = !!(match && match.available);
    if (button) {
      button.disabled = !ok;
      button.textContent = ok ? button.getAttribute('data-label') : button.getAttribute('data-soldout');
    }
    if (match) {
      renderOffers(box, match);
      var now = box.querySelector('[data-zs-price-now]');
      if (now) now.textContent = money(match.price, box);
      if (match.image) setMain(document.querySelector('[data-zs-gallery]'), match.image);
      if (box.getAttribute('data-update-url') === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  function initSticky() {
    var bar = document.querySelector('[data-zs-sticky]');
    var target = document.querySelector('[data-zs-submit]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.setAttribute('data-show', (!en.isIntersecting && en.boundingClientRect.top < 0) ? 'true' : 'false');
    }).observe(target);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
